import { MicroMoments } from '../models/micro-moments.interfaces';

export const MicroMomentsUpcomingMilesMocks: MicroMoments = {
  id: '',
  title: 'You’ve Got Upcoming Miles',
  description:
    'Your recently booked trip is helping boost your Medallion Status.',
  action: {
    label: 'View Your Account Activity',
    url: 'https://www.delta.com/acctactvty/manageacctactvty.action'
  },
  logo: {
    src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/moments/upcoming-miles.gif',
    alt: 'Upcoming Miles Logo'
  },
  close: {
    path: '#',
    alt: 'close'
  },
  ariaLabel: {
    close: 'Close Micromoment'
  },
  disabled: false,
  loaded: true
};
